import styled from 'styled-components';

import {
  colorAccent50,
  colorBlack900,
  fontFamilyPrimary,
  fontFamilySecondary,
  mediaQueryTabletMin,
} from '@/styleUtils';

export const ActionsItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
  padding: 16px;
  border-radius: 12px;
  background: ${colorAccent50};
  color: ${colorBlack900};
  transition: 0.8s;

  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }

  @media ${mediaQueryTabletMin} {
    gap: 12px;
    padding: 16px 24px;
  }
`;

export const ActionsItemTitle = styled.p`
  display: flex;
  justify-content: space-between;
  font: 700 16px/24px ${fontFamilySecondary};
`;

export const ActionsItemText = styled.p`
  font: 400 14px/24px ${fontFamilyPrimary};
`;
